(function (window, document) {
  "use strict";

  var STORAGE_KEY = "aiplaces.accessibilityPreferences";
  var DEFAULTS = {
    fontSize: "normal",
    highContrast: false,
    grayscale: false,
    underlineLinks: false,
    readableFont: false,
    reduceMotion: false,
    focusMode: false,
    textSpacing: false
  };

  var CLASS_MAP = {
    fontLarge: "ap-a11y-font-large",
    fontXLarge: "ap-a11y-font-xlarge",
    highContrast: "ap-a11y-contrast",
    grayscale: "ap-a11y-grayscale",
    underlineLinks: "ap-a11y-underline-links",
    readableFont: "ap-a11y-readable-font",
    reduceMotion: "ap-a11y-reduce-motion",
    focusMode: "ap-a11y-focus-mode",
    textSpacing: "ap-a11y-text-spacing"
  };

  var TOGGLES = [
    "highContrast",
    "grayscale",
    "underlineLinks",
    "readableFont",
    "reduceMotion",
    "focusMode",
    "textSpacing"
  ];
  var lastTrigger = null;

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function parsePreferences(value) {
    try {
      return JSON.parse(value || "{}") || {};
    } catch (error) {
      return {};
    }
  }

  function readPreferences() {
    var stored = {};

    try {
      stored = parsePreferences(window.localStorage.getItem(STORAGE_KEY));
    } catch (error) {
      stored = {};
    }

    return Object.assign({}, DEFAULTS, stored);
  }

  function writePreferences(preferences) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
    } catch (error) {
      // Keep the UI usable when localStorage is unavailable.
    }
  }

  function removePreferences() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      // No-op.
    }
  }

  function setClass(root, className, enabled) {
    root.classList.toggle(className, Boolean(enabled));
  }

  function applyPreferences(preferences) {
    var root = document.documentElement;

    root.classList.remove(CLASS_MAP.fontLarge, CLASS_MAP.fontXLarge);

    if (preferences.fontSize === "large") {
      root.classList.add(CLASS_MAP.fontLarge);
    } else if (preferences.fontSize === "xlarge") {
      root.classList.add(CLASS_MAP.fontXLarge);
    }

    TOGGLES.forEach(function (key) {
      setClass(root, CLASS_MAP[key], preferences[key]);
    });
  }

  function announce(message) {
    var status = document.querySelector("[data-a11y-status]");

    if (status) {
      status.textContent = message;
    }
  }

  function syncControls(preferences) {
    Array.prototype.slice.call(document.querySelectorAll("[data-a11y-font]")).forEach(function (button) {
      var selected = button.getAttribute("data-a11y-font") === preferences.fontSize;
      button.setAttribute("aria-pressed", selected ? "true" : "false");
    });

    TOGGLES.forEach(function (key) {
      Array.prototype.slice.call(document.querySelectorAll('[data-a11y-toggle="' + key + '"]')).forEach(function (button) {
        button.setAttribute("aria-pressed", preferences[key] ? "true" : "false");
      });
    });
  }

  function saveAndApply(preferences, message) {
    applyPreferences(preferences);
    syncControls(preferences);
    writePreferences(preferences);
    announce(message || "הגדרות הנגישות עודכנו.");
  }

  function setPanelOpen(open) {
    var panel = document.querySelector("[data-a11y-panel]");
    var openButtons = Array.prototype.slice.call(document.querySelectorAll("[data-a11y-open]"));

    if (!panel || openButtons.length === 0) {
      return;
    }

    panel.hidden = !open;
    panel.classList.toggle("is-open", open);
    panel.setAttribute("aria-hidden", open ? "false" : "true");
    openButtons.forEach(function (button) {
      button.setAttribute("aria-expanded", open ? "true" : "false");
    });

    if (open) {
      var closeButton = panel.querySelector("[data-a11y-action='close']");
      if (closeButton) {
        closeButton.focus();
      }
    } else {
      if (lastTrigger && typeof lastTrigger.focus === "function") {
        lastTrigger.focus();
      }
    }
  }

  function init() {
    var panel = document.querySelector("[data-a11y-panel]");
    var openButtons = Array.prototype.slice.call(document.querySelectorAll("[data-a11y-open]"));

    if (!panel || openButtons.length === 0) {
      applyPreferences(readPreferences());
      return;
    }

    var preferences = readPreferences();
    applyPreferences(preferences);
    syncControls(preferences);

    openButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        lastTrigger = button;
        setPanelOpen(panel.hidden);
      });
    });

    panel.addEventListener("click", function (event) {
      var target = event.target;
      var actionButton = target && typeof target.closest === "function"
        ? target.closest("[data-a11y-action], [data-a11y-font], [data-a11y-toggle]")
        : null;

      if (!actionButton || !panel.contains(actionButton)) {
        return;
      }

      event.preventDefault();

      var action = actionButton.getAttribute("data-a11y-action");
      var fontSize = actionButton.getAttribute("data-a11y-font");
      var toggleKey = actionButton.getAttribute("data-a11y-toggle");

      if (action === "close") {
        setPanelOpen(false);
        return;
      }

      if (action === "reset") {
        preferences = Object.assign({}, DEFAULTS);
        removePreferences();
        applyPreferences(preferences);
        syncControls(preferences);
        announce("הגדרות הנגישות אופסו.");
        return;
      }

      if (fontSize) {
        preferences.fontSize = fontSize;
        saveAndApply(preferences, "גודל הטקסט עודכן.");
        return;
      }

      if (toggleKey && Object.prototype.hasOwnProperty.call(preferences, toggleKey)) {
        preferences[toggleKey] = !preferences[toggleKey];
        saveAndApply(preferences, "הגדרת הנגישות עודכנה.");
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !panel.hidden) {
        setPanelOpen(false);
      }
    });
  }

  window.AiPlacesAccessibility = {
    apply: applyPreferences,
    getPreferences: readPreferences,
    reset: function () {
      removePreferences();
      applyPreferences(DEFAULTS);
      syncControls(DEFAULTS);
    }
  };

  onReady(init);
})(window, document);
